import type { WebModule } from "../../core/modules";
import { DemandesPage } from "./routes/demandes";
import { SitePage } from "./routes/site";

// Site public PROTECTO : réglages de la réservation en ligne, de l'acompte et
// des coordonnées affichées. Le site lui-même est statique (apps/site).
const site: WebModule = {
  name: "x-site",
  routes: [
    { path: "/site/demandes", element: <DemandesPage />, adminOnly: true },
    { path: "/site", element: <SitePage />, adminOnly: true },
  ],
  nav: [
    {
      title: "Site web",
      order: 60,
      adminOnly: true,
      items: [
        { to: "/site/demandes", label: "Demandes du site", icon: "message", adminOnly: true },
        {
          to: "/site",
          label: "Réservation en ligne",
          icon: "external",
          end: true,
          adminOnly: true,
        },
      ],
    },
  ],
};

export default site;
